import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Home from "../features/home/home";
import Login from "../features/login/login";
import Score from "../features/score/score";

const MainRouter = () => {
  return (
    <Router>
      <Switch>
        <Route exact path="/expert/" component={Home} />
        <Route exact path="/expert/login" component={Login} />
        <Route exact path="/expert/home" component={Home} />
        <Route exact path="/expert/score/:id" component={Score} />

        <Redirect to="/" />
      </Switch>
    </Router>
  );
};

export default MainRouter;
